/* ============================================================
   MyGlowRoots — vanilla JS behavior layer
   Covers: header (mobile drawer, mega menu, search), cart &
   wishlist (localStorage), accordions, tabs, product gallery,
   qty stepper, hero slider, shop filters/sort/pagination,
   blog filters, doc/article scrollspy, forms.
   ============================================================ */
(function () {
  'use strict';

  var WISH_KEY = 'mgr_wish';

  /* ---------- storage helpers ---------- */
  function readJSON(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key)) || fallback; } catch (e) { return fallback; }
  }
  function getWishlist() { return readJSON(WISH_KEY, []); }
  function setWishlist(list) { localStorage.setItem(WISH_KEY, JSON.stringify(list)); updateWishCount(); syncWishButtons(); }

  /* ============================================================
     Header: mobile drawer
     ============================================================ */
  function initMobileDrawer() {
    var toggle = document.querySelector('.mobile-toggle');
    var drawer = document.getElementById('mobileDrawer');
    var overlay = document.getElementById('mobileDrawerOverlay');
    var closeBtn = document.querySelector('[data-close="mobileDrawer"]');
    if (!toggle || !drawer || !overlay) return;
    function open() { drawer.classList.add('open'); overlay.classList.add('open'); }
    function close() { drawer.classList.remove('open'); overlay.classList.remove('open'); }
    toggle.addEventListener('click', open);
    overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
  }

  /* ============================================================
     Header: mega menu (hover on desktop, click on touch)
     ============================================================ */
  function initMegaMenu() {
    var trigger = document.querySelector('[data-mega-trigger]');
    var menu = document.getElementById('megaMenu');
    if (!trigger || !menu) return;
    var headerRow = trigger.closest('.header-row');
    var hideTimer;
    function show() { clearTimeout(hideTimer); menu.classList.add('open'); }
    function scheduleHide() { hideTimer = setTimeout(function () { menu.classList.remove('open'); }, 150); }
    trigger.addEventListener('mouseenter', show);
    if (headerRow) headerRow.addEventListener('mouseleave', scheduleHide);
    menu.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    menu.addEventListener('mouseleave', scheduleHide);
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      menu.classList.toggle('open');
    });
    document.addEventListener('click', function (e) {
      if (!menu.contains(e.target) && !trigger.contains(e.target)) menu.classList.remove('open');
    });
  }

  /* ============================================================
     Header: search overlay
     ============================================================ */
  function initSearchOverlay() {
    var openBtn = document.querySelector('[data-action="search"]');
    var overlay = document.getElementById('searchOverlay');
    if (!openBtn || !overlay) return;
    var closeBtn = overlay.querySelector('[data-close="searchOverlay"]');
    var input = overlay.querySelector('input');
    function open() { overlay.classList.add('open'); setTimeout(function () { input && input.focus(); }, 50); }
    function close() { overlay.classList.remove('open'); }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelectorAll('[data-suggest]').forEach(function (btn) {
      btn.addEventListener('click', function () { input.value = btn.textContent; });
    });
    var form = overlay.querySelector('form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = (input.value || '').trim();
      window.location.href = '/search' + (q ? ('?q=' + encodeURIComponent(q) + '&type=product') : '');
    });
  }

  /* ============================================================
     Cart drawer
     ============================================================ */
  function updateWishCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function tintBg(tint) {
    tint = tint || '#e9b873';
    return 'radial-gradient(120% 120% at 30% 18%, ' + tint + '55, transparent 60%), linear-gradient(160deg, var(--cream-200), var(--sand-300))';
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartDrawerOverlay');
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
  }
  function closeCartDrawer() {
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartDrawerOverlay');
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
  }

  function initCartDrawer() {
    var openBtn = document.querySelector('[data-action="cart"]');
    var overlay = document.getElementById('cartDrawerOverlay');
    var closeBtn = document.querySelector('[data-close="cartDrawer"]');
    if (openBtn) openBtn.addEventListener('click', openCartDrawer);
    if (overlay) overlay.addEventListener('click', closeCartDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    /* Drawer contents and the count badge are rendered from the real Shopify
       cart by refreshCartDrawer(); rendering the localStorage cart here would
       overwrite it. */
  }

  /* Add-to-cart is handled entirely by the real Shopify cart code further down
     (form submit on the PDP, click on product cards). The demo handler that
     used to live here called preventDefault() on the PDP's type="submit"
     button, which cancelled the form submit so /cart/add.js never ran. */

  /* ============================================================
     Wishlist heart buttons
     ============================================================ */
  function syncWishButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wish-toggle]').forEach(function (btn) {
      var card = btn.closest('[data-product]');
      var id = card ? card.getAttribute('data-product') : btn.getAttribute('data-wish-toggle');
      btn.classList.toggle('active', list.indexOf(id) !== -1);
    });
  }
  function initWishlistButtons() {
    document.querySelectorAll('[data-wish-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('[data-product]');
        var id = card ? card.getAttribute('data-product') : btn.getAttribute('data-wish-toggle');
        var list = getWishlist();
        var idx = list.indexOf(id);
        if (idx === -1) list.push(id); else list.splice(idx, 1);
        setWishlist(list);
      });
    });
    syncWishButtons();
    updateWishCount();
  }

  /* ============================================================
     Accordion (FAQ / doc pages)
     ============================================================ */
  function initAccordions() {
    document.querySelectorAll('.accordion-item').forEach(function (item) {
      var trigger = item.querySelector('.accordion-trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        item.parentElement.querySelectorAll('.accordion-item.open').forEach(function (openItem) {
          if (openItem !== item && openItem.parentElement === item.parentElement) openItem.classList.remove('open');
        });
        item.classList.toggle('open', !wasOpen);
      });
    });
  }

  /* ============================================================
     Tabs (product detail)
     ============================================================ */
  function initTabs() {
    document.querySelectorAll('.tabs').forEach(function (tabs) {
      var panels = document.querySelectorAll('[data-tab-panel]');
      tabs.querySelectorAll('.tab-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-tab');
          tabs.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          panels.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-tab-panel') === target); });
        });
      });
    });
  }

  /* ============================================================
     Product gallery thumbnails
     ============================================================ */
  function initGallery() {
    var thumbs = document.querySelectorAll('.gallery-thumb');
    var mainImg = document.querySelector('.gallery-main img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var nextSrc = thumb.getAttribute('data-gallery-src');
        var nextAlt = thumb.getAttribute('data-gallery-alt');
        if (nextSrc) {
          mainImg.src = nextSrc;
          mainImg.removeAttribute('srcset');
          mainImg.style.transform = '';
        }
        if (nextAlt) mainImg.alt = nextAlt;
      });
    });
  }

  /* ============================================================
     Quantity stepper
     ============================================================ */
  function initQtyStepper() {
    document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
      var valueEl = stepper.querySelector('[data-qty-value]');
      var minus = stepper.querySelector('[data-qty-minus]');
      var plus = stepper.querySelector('[data-qty-plus]');
      if (!valueEl) return;
      minus && minus.addEventListener('click', function () {
        valueEl.textContent = Math.max(1, parseInt(valueEl.textContent, 10) - 1);
      });
      plus && plus.addEventListener('click', function () {
        valueEl.textContent = parseInt(valueEl.textContent, 10) + 1;
      });
    });
  }

  /* ============================================================
     Product variant selector
     ============================================================ */
  function initVariantButtons() {
    var groups = document.querySelectorAll('.variant-options');
    if (!groups.length) return;
    var form = document.getElementById('product-form-main');
    var jsonEl = document.querySelector('[data-product-json]');
    var product = null;
    if (jsonEl) { try { product = JSON.parse(jsonEl.textContent); } catch (e) { product = null; } }

    /* Marking a button .active is cosmetic; the variant that actually gets
       added is whatever is in the form's hidden id input, so resolve the
       selected options back to a variant and write that id. */
    function syncSelectedVariant() {
      if (!product || !form) return;
      var chosen = Array.prototype.map.call(groups, function (group) {
        var active = group.querySelector('.variant-btn.active');
        return active ? active.textContent.trim() : null;
      });
      var match = product.variants.filter(function (variant) {
        return chosen.every(function (value, i) { return value === null || variant.options[i] === value; });
      })[0];
      if (!match) return;

      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
      var root = document.querySelector('[data-product][data-variant-id]');
      if (root) root.setAttribute('data-variant-id', match.id);

      var price = document.querySelector('.pdp-price .now');
      if (price && window.MGR_CART) price.textContent = window.MGR_CART.money(match.price);
      /* Leave the button's markup alone -- it holds an inline SVG icon. */
      var addBtn = form.querySelector('[data-pdp-add]');
      if (addBtn) addBtn.disabled = !match.available;
    }

    Array.prototype.forEach.call(groups, function (group) {
      group.querySelectorAll('.variant-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          syncSelectedVariant();
        });
      });
    });
    syncSelectedVariant();
  }

  /* ============================================================
     Hero slider
     ============================================================ */
  function initHeroSlider() {
    var slider = document.querySelector('.hero-slider');
    if (!slider) return;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.hero-slide'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('.hero-dots button'));
    var prevBtn = slider.querySelector('.hero-arrow.prev');
    var nextBtn = slider.querySelector('.hero-arrow.next');
    var i = 0, n = slides.length, timer, paused = false;

    function show(idx) {
      i = ((idx % n) + n) % n;
      slides.forEach(function (s, si) { s.classList.toggle('active', si === i); });
      dots.forEach(function (d, di) { d.classList.toggle('active', di === i); });
    }
    function next() { show(i + 1); }
    function prev() { show(i - 1); }
    function restart() { clearInterval(timer); timer = setInterval(function () { if (!paused) next(); }, 5000); }

    dots.forEach(function (d, di) { d.addEventListener('click', function () { show(di); restart(); }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    slider.addEventListener('mouseenter', function () { paused = true; });
    slider.addEventListener('mouseleave', function () { paused = false; });

    var touchX = null;
    slider.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 44) { dx < 0 ? next() : prev(); restart(); }
      touchX = null;
    });

    show(0);
    restart();
  }

  /* ============================================================
     Announcement bar rotating messages
     ============================================================ */
  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    var messages = bar.querySelectorAll('[data-announcement-message]');
    if (messages.length < 2) return;
    var speed = parseInt(bar.getAttribute('data-rotation-speed'), 10);
    if (!speed || speed < 1000) speed = 4200;
    var i = 0;
    setInterval(function () {
      messages[i].hidden = true;
      i = (i + 1) % messages.length;
      messages[i].hidden = false;
    }, speed);
  }

  /* ============================================================
     Shop / collection filters, sort & pagination
     ============================================================ */
  function initShopFilters() {
    var grid = document.getElementById('productsGrid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product]'));
    var countEl = document.getElementById('shopCount');
    var emptyState = document.getElementById('shopEmpty');
    var pagination = document.getElementById('shopPagination');
    var perPage = 8;
    var page = 1;

    var params = new URLSearchParams(window.location.search);
    var qParam = (params.get('q') || params.get('query') || '').toLowerCase();
    var catParam = params.get('category');

    var state = { cats: catParam ? [catParam] : [], types: [], maxPrice: 100, inStock: false, minRating: 0, sort: 'featured', q: qParam };

    function matches(card) {
      var cat = card.getAttribute('data-category');
      var type = card.getAttribute('data-type');
      var price = parseFloat(card.getAttribute('data-price'));
      var stock = card.getAttribute('data-stock');
      var rating = parseFloat(card.getAttribute('data-rating'));
      var name = (card.getAttribute('data-name') || '').toLowerCase();
      if (state.cats.length && state.cats.indexOf(cat) === -1) return false;
      if (state.types.length && state.types.indexOf(type) === -1) return false;
      if (price > state.maxPrice) return false;
      if (state.inStock && stock !== 'in') return false;
      if (state.minRating && rating < state.minRating) return false;
      if (state.q && name.indexOf(state.q) === -1) return false;
      return true;
    }

    function sortCards(list) {
      var sorted = list.slice();
      if (state.sort === 'price-asc') sorted.sort(function (a, b) { return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price')); });
      if (state.sort === 'price-desc') sorted.sort(function (a, b) { return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price')); });
      if (state.sort === 'rating') sorted.sort(function (a, b) { return parseFloat(b.getAttribute('data-rating')) - parseFloat(a.getAttribute('data-rating')); });
      if (state.sort === 'reviews') sorted.sort(function (a, b) { return parseInt(b.getAttribute('data-reviews'), 10) - parseInt(a.getAttribute('data-reviews'), 10); });
      return sorted;
    }

    function render() {
      var filtered = sortCards(cards.filter(matches));
      cards.forEach(function (c) { c.style.display = 'none'; });
      var totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
      if (page > totalPages) page = totalPages;
      var slice = filtered.slice((page - 1) * perPage, page * perPage);
      slice.forEach(function (c) { c.style.display = ''; grid.appendChild(c); });
      if (countEl) countEl.textContent = filtered.length + (filtered.length === 1 ? ' product' : ' products');
      if (emptyState) emptyState.style.display = filtered.length === 0 ? 'block' : 'none';
      grid.style.display = filtered.length === 0 ? 'none' : 'grid';
      renderPagination(totalPages);
    }

    function renderPagination(totalPages) {
      if (!pagination) return;
      if (totalPages <= 1) { pagination.innerHTML = ''; return; }
      var html = '<button class="page-btn" data-page="prev"' + (page === 1 ? ' disabled' : '') + '>&larr;</button>';
      for (var p = 1; p <= totalPages; p++) {
        html += '<button class="page-btn' + (p === page ? ' active' : '') + '" data-page="' + p + '">' + p + '</button>';
      }
      html += '<button class="page-btn" data-page="next"' + (page === totalPages ? ' disabled' : '') + '>&rarr;</button>';
      pagination.innerHTML = html;
      pagination.querySelectorAll('[data-page]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.getAttribute('data-page');
          if (v === 'prev') page = Math.max(1, page - 1);
          else if (v === 'next') page = Math.min(totalPages, page + 1);
          else page = parseInt(v, 10);
          render();
          window.scrollTo({ top: grid.offsetTop - 100, behavior: 'smooth' });
        });
      });
    }

    // category checkboxes
    document.querySelectorAll('[data-filter-cat]').forEach(function (row) {
      var val = row.getAttribute('data-filter-cat');
      if (state.cats.indexOf(val) !== -1) row.classList.add('checked');
      row.addEventListener('click', function () {
        var idx = state.cats.indexOf(val);
        if (idx === -1) state.cats.push(val); else state.cats.splice(idx, 1);
        row.classList.toggle('checked');
        page = 1; render();
      });
    });
    // type checkboxes
    document.querySelectorAll('[data-filter-type]').forEach(function (row) {
      var val = row.getAttribute('data-filter-type');
      row.addEventListener('click', function () {
        var idx = state.types.indexOf(val);
        if (idx === -1) state.types.push(val); else state.types.splice(idx, 1);
        row.classList.toggle('checked');
        page = 1; render();
      });
    });
    // price range
    var priceRange = document.querySelector('[data-filter-price]');
    var priceLabel = document.querySelector('[data-price-label]');
    if (priceRange) {
      priceRange.addEventListener('input', function () {
        state.maxPrice = parseFloat(priceRange.value);
        if (priceLabel) priceLabel.textContent = 'Up to $' + state.maxPrice;
        page = 1; render();
      });
    }
    // rating radios
    document.querySelectorAll('[data-filter-rating]').forEach(function (row) {
      row.addEventListener('click', function () {
        document.querySelectorAll('[data-filter-rating]').forEach(function (r) { r.classList.remove('checked'); });
        row.classList.add('checked');
        state.minRating = parseFloat(row.getAttribute('data-filter-rating'));
        page = 1; render();
      });
    });
    // in stock only
    var stockRow = document.querySelector('[data-filter-stock]');
    if (stockRow) stockRow.addEventListener('click', function () {
      state.inStock = !state.inStock;
      stockRow.classList.toggle('checked', state.inStock);
      page = 1; render();
    });
    // sort
    var sortSelect = document.getElementById('sortSelect');
    if (sortSelect) sortSelect.addEventListener('change', function () { state.sort = sortSelect.value; page = 1; render(); });
    // clear all
    var clearBtn = document.querySelector('[data-clear-filters]');
    if (clearBtn) clearBtn.addEventListener('click', function () {
      state.cats = []; state.types = []; state.maxPrice = 100; state.inStock = false; state.minRating = 0; state.q = '';
      document.querySelectorAll('[data-filter-cat],[data-filter-type],[data-filter-stock]').forEach(function (r) { r.classList.remove('checked'); });
      document.querySelectorAll('[data-filter-rating]').forEach(function (r) { r.classList.remove('checked'); });
      if (priceRange) priceRange.value = 100;
      if (priceLabel) priceLabel.textContent = 'Up to $100';
      page = 1; render();
    });

    // mobile filter drawer
    var filtersDrawer = document.getElementById('filtersDrawer');
    var filtersOverlay = document.getElementById('filtersDrawerOverlay');
    var filtersToggle = document.querySelector('.filters-toggle');
    var filtersClose = document.querySelector('[data-close="filtersDrawer"]');
    if (filtersToggle && filtersDrawer) {
      filtersToggle.addEventListener('click', function () { filtersDrawer.classList.add('open'); filtersOverlay.classList.add('open'); });
    }
    function closeFiltersDrawer() { filtersDrawer.classList.remove('open'); filtersOverlay.classList.remove('open'); }
    if (filtersClose) filtersClose.addEventListener('click', closeFiltersDrawer);
    if (filtersOverlay) filtersOverlay.addEventListener('click', closeFiltersDrawer);

    render();
  }

  /* ============================================================
     Collection page: single-select category pill filter
     ============================================================ */
  function initCollectionFilters() {
    var panelWrap = document.getElementById('collectionPanels');
    if (!panelWrap) return;
    var panels = Array.prototype.slice.call(panelWrap.querySelectorAll('.collection-panel'));
    var pills = Array.prototype.slice.call(document.querySelectorAll('[data-collection-cat]'));
    var countEl = document.getElementById('collectionCount');

    function panelFor(handle) {
      return panels.filter(function (p) { return p.getAttribute('data-panel') === handle; })[0];
    }
    function countIn(panel) {
      return panel ? panel.querySelectorAll('[data-product]').length : 0;
    }
    function activate(handle) {
      panels.forEach(function (p) { p.style.display = p.getAttribute('data-panel') === handle ? '' : 'none'; });
      pills.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-collection-cat') === handle); });
      if (countEl) {
        var n = countIn(panelFor(handle));
        countEl.textContent = n + (n === 1 ? ' product' : ' products');
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () { activate(pill.getAttribute('data-collection-cat')); });
    });
    // Sync the initial count with the products actually rendered in the "all" panel.
    activate('all');
  }

  /* ============================================================
     Blog category filter + search
     ============================================================ */
  function initBlogFilters() {
    var grid = document.getElementById('blogGrid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-post]'));
    var searchInput = document.querySelector('[data-blog-search]');
    var emptyState = document.getElementById('blogEmpty');
    var activeCat = 'All';

    function render() {
      var q = (searchInput && searchInput.value || '').toLowerCase();
      var visible = 0;
      cards.forEach(function (card) {
        var cat = card.getAttribute('data-category');
        var text = (card.getAttribute('data-search') || '').toLowerCase();
        var show = (activeCat === 'All' || cat === activeCat) && (!q || text.indexOf(q) !== -1);
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (emptyState) emptyState.style.display = visible === 0 ? 'block' : 'none';
    }
    document.querySelectorAll('[data-blog-cat]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        activeCat = btn.getAttribute('data-blog-cat');
        document.querySelectorAll('[data-blog-cat]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        document.querySelectorAll('.blog-cat-btn[data-blog-cat="' + activeCat + '"]').forEach(function (b) { b.classList.add('active'); });
        render();
        window.scrollTo({ top: grid.offsetTop - 120, behavior: 'smooth' });
      });
    });
    if (searchInput) searchInput.addEventListener('input', render);
    render();
  }

  /* ============================================================
     Doc / article scrollspy TOC
     ============================================================ */
  function initScrollspy() {
    document.querySelectorAll('[data-toc]').forEach(function (toc) {
      var links = Array.prototype.slice.call(toc.querySelectorAll('a'));
      if (!links.length || typeof IntersectionObserver === 'undefined') return;
      var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            links.forEach(function (a) { a.classList.remove('active'); });
            var match = links.find(function (a) { return a.getAttribute('href') === '#' + entry.target.id; });
            if (match) match.classList.add('active');
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
      targets.forEach(function (t) { observer.observe(t); });
      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(a.getAttribute('href').slice(1));
          if (target) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
        });
      });
    });
  }

  /* ============================================================
     Forms: contact, newsletter (fake submit + success state)
     ============================================================ */
  function initFakeForms() {
    document.querySelectorAll('[data-fake-submit]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var successId = form.getAttribute('data-fake-submit');
        var successEl = successId ? document.getElementById(successId) : null;
        if (successEl) {
          form.style.display = 'none';
          successEl.style.display = 'block';
          window.scrollTo({ top: form.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
        } else {
          var input = form.querySelector('input[type=email]');
          var wrap = form.parentElement;
          form.style.display = 'none';
          var msg = document.createElement('div');
          msg.className = 'newsletter-success';
          msg.textContent = 'You’re in — check your inbox for 10% off.';
          wrap.appendChild(msg);
        }
      });
    });
    document.querySelectorAll('[data-reset-form]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var formId = btn.getAttribute('data-reset-form');
        var form = document.getElementById(formId);
        var success = form ? form.nextElementSibling : null;
        if (form) form.style.display = 'grid';
        if (success) success.style.display = 'none';
      });
    });
  }

  /* ============================================================
     Newsletter popup (first visit, after delay)
     ============================================================ */
  function initNewsletterPopup() {
    var popup = document.getElementById('newsletterPopup');
    if (!popup) return;
    if (sessionStorage.getItem('mgr_nl_seen')) return;
    var overlay = document.getElementById('popupOverlay');
    var closeBtn = popup.querySelector('[data-close="newsletterPopup"]');
    setTimeout(function () {
      overlay.classList.add('open');
      sessionStorage.setItem('mgr_nl_seen', '1');
    }, 6000);
    function close() { overlay.classList.remove('open'); }
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  }

  /* ============================================================
     Quick view modal (shop grid "Quick view" buttons)
     ============================================================ */
  function initQuickView() {
    var overlay = document.getElementById('quickViewOverlay');
    if (!overlay) return;
    var modal = document.getElementById('quickView');
    var closeBtn = overlay.querySelector('[data-close="quickView"]');
    document.querySelectorAll('[data-quick-view]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var card = btn.closest('[data-product]');
        if (!card || !modal) return;
        modal.querySelector('[data-qv-media]').style.background = tintBg(card.getAttribute('data-tint'));
        modal.querySelector('[data-qv-name]').textContent = card.getAttribute('data-name');
        modal.querySelector('[data-qv-cat]').textContent = card.getAttribute('data-note') || '';
        modal.querySelector('[data-qv-desc]').textContent = card.getAttribute('data-desc') || '';
        modal.querySelector('[data-qv-price]').textContent = '$' + card.getAttribute('data-price');
        modal.setAttribute('data-active-product', card.getAttribute('data-product'));
        modal.setAttribute('data-active-variant', card.getAttribute('data-variant-id') || '');
        modal.querySelector('[data-qv-name]').setAttribute('data-price', card.getAttribute('data-price'));
        var link = modal.querySelector('[data-qv-link]');
        if (link) link.href = card.querySelector('.product-card-link') ? card.querySelector('.product-card-link').href : '/collections/all';
        overlay.classList.add('open');
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { overlay.classList.remove('open'); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.classList.remove('open'); });
    var addBtn = modal ? modal.querySelector('[data-qv-add]') : null;
    if (addBtn) addBtn.addEventListener('click', function () {
      var variantId = modal.getAttribute('data-active-variant');
      if (!variantId || !window.MGR_CART) return;
      window.MGR_CART.add(variantId, 1);
      overlay.classList.remove('open');
    });
  }

  /* ============================================================
     Init on DOM ready
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    initMobileDrawer();
    initMegaMenu();
    initSearchOverlay();
    initCartDrawer();
    initWishlistButtons();
    initAccordions();
    initTabs();
    initGallery();
    initQtyStepper();
    initVariantButtons();
    initHeroSlider();
    initAnnouncementBar();
    initShopFilters();
    initCollectionFilters();
    initBlogFilters();
    initScrollspy();
    initFakeForms();
    initNewsletterPopup();
    initQuickView();
  });
})();


(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sort-form .sort-select').forEach(function (select) {
      select.addEventListener('change', function () {
        select.form.submit();
      });
    });
  });
})();


(function () {
  if (!window.MGR_THEME) return;
  function money(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    var format = (window.MGR_THEME.moneyFormat || 'Rs.{{amount}}').replace(/<[^>]*>/g, '');
    return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(',', '#').replace('.', ',').replace('#', '.'));
  }
  function refreshCartDrawer() {
    return fetch(window.MGR_THEME.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count ? 'grid' : 'none'; });
      var title = document.getElementById('cartDrawerTitle'); var body = document.getElementById('cartDrawerBody'); var foot = document.getElementById('cartDrawerFoot'); var subtotal = document.getElementById('cartSubtotal');
      if (title) title.textContent = 'Your bag (' + cart.item_count + ')'; if (subtotal) subtotal.textContent = money(cart.total_price); if (!body) return;
      if (!cart.items.length) { body.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p></div>'; if (foot) foot.style.display = 'none'; return; }
      if (foot) foot.style.display = 'block';
      body.innerHTML = cart.items.map(function (it, i) { return '<div class="cart-item"><div class="cart-item-media"><img src="' + (it.image || window.MGR_THEME.leafAsset) + '" alt=""></div><div class="cart-item-info"><div class="cart-item-name">' + it.product_title + '</div><div class="cart-item-meta">' + (it.variant_title || '') + ' &middot; Qty ' + it.quantity + '</div><button class="cart-item-remove" data-shopify-remove="' + (i + 1) + '">Remove</button></div><div class="cart-item-price">' + money(it.final_line_price) + '</div></div>'; }).join('');
      body.querySelectorAll('[data-shopify-remove]').forEach(function (btn) { btn.addEventListener('click', function () { fetch(window.MGR_THEME.cartChangeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(btn.getAttribute('data-shopify-remove')), quantity: 0 }) }).then(refreshCartDrawer); }); });
    });
  }
  function openCartDrawer() {
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartDrawerOverlay');
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
  }
  /* Shopify rejects an add with a 4xx + JSON body. Surface it instead of
     opening the drawer, so the drawer can never claim a failed add succeeded. */
  function postAdd(init) {
    return fetch(window.MGR_THEME.cartAddUrl + '.js', init).then(function (res) {
      if (res.ok) return res.json();
      return res.json().catch(function () { return {}; }).then(function (err) {
        throw new Error(err.description || err.message || 'This item could not be added to your bag.');
      });
    }).then(function () {
      return refreshCartDrawer();
    }).then(function () {
      openCartDrawer();
    }).catch(function (err) {
      window.alert(err.message);
    });
  }
  function addVariantToCart(id, quantity) {
    if (!id) return Promise.resolve();
    return postAdd({
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: Number(quantity) || 1 })
    });
  }
  /* Shared with the demo-era code in the first IIFE (quick view), which has no
     access to this scope. */
  window.MGR_CART = { add: addVariantToCart, refresh: refreshCartDrawer, open: openCartDrawer, money: money };

  document.addEventListener('DOMContentLoaded', refreshCartDrawer);
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]'); if (!form) return;
    event.preventDefault(); var qty = form.querySelector('[data-qty-value]'); var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) { qtyInput = document.createElement('input'); qtyInput.type = 'hidden'; qtyInput.name = 'quantity'; form.appendChild(qtyInput); }
    qtyInput.value = qty ? qty.textContent : '1';
    postAdd({ method: 'POST', body: new FormData(form) });
  }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-add-to-cart]'); if (!button || button.closest('form')) return;
    var card = button.closest('[data-product]'); if (!card) return; var id = card.getAttribute('data-variant-id'); if (!id) return;
    event.preventDefault();
    addVariantToCart(id, 1);
  }, true);
  var cartPageTimers = {};
  function updateCartPageQuantity(input) {
    var line = Number(input.getAttribute('data-line'));
    var quantity = Math.max(0, Number(input.value) || 0);
    input.value = quantity;
    input.disabled = true;
    fetch(window.MGR_THEME.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items.length) {
        window.location.reload();
        return;
      }
      cart.items.forEach(function (item, index) {
        var row = document.querySelector('[data-cart-page-line="' + (index + 1) + '"]');
        if (!row) return;
        var price = row.querySelector('[data-cart-page-line-price]');
        var qty = row.querySelector('[data-cart-page-qty]');
        if (price) price.textContent = money(item.final_line_price);
        if (qty) {
          qty.value = item.quantity;
          qty.setAttribute('data-line', index + 1);
        }
      });
      document.querySelectorAll('[data-cart-page-line]').forEach(function (row, index) {
        if (!cart.items[index]) row.remove();
      });
      var subtotal = document.querySelector('[data-cart-page-subtotal]');
      if (subtotal) subtotal.textContent = money(cart.total_price);
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count ? 'grid' : 'none'; });
      refreshCartDrawer();
    }).finally(function () {
      input.disabled = false;
    });
  }
  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-cart-page-qty]');
    if (!input) return;
    var line = input.getAttribute('data-line');
    window.clearTimeout(cartPageTimers[line]);
    cartPageTimers[line] = window.setTimeout(function () {
      updateCartPageQuantity(input);
    }, 450);
  });
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-page-qty]');
    if (!input) return;
    var line = input.getAttribute('data-line');
    window.clearTimeout(cartPageTimers[line]);
    updateCartPageQuantity(input);
  });
})();


(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var jsonEl = document.querySelector('[data-product-json]');
    var form = document.querySelector('#product-form-main');
    if (!jsonEl || !form) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var hidden = form.querySelector('input[name="id"]');
    function selectedOptions() {
      return Array.prototype.slice.call(form.querySelectorAll('.variant-options')).map(function (group) {
        var active = group.querySelector('.variant-btn.active');
        return active ? active.textContent.trim() : '';
      });
    }
    function updateVariant() {
      var selected = selectedOptions();
      var variant = product.variants.find(function (item) {
        return selected.every(function (value, index) { return item.options[index] === value; });
      });
      if (variant && hidden) hidden.value = variant.id;
      var root = document.querySelector('[data-product="' + product.handle + '"]');
      if (root && variant) root.setAttribute('data-variant-id', variant.id);
    }
    form.querySelectorAll('.variant-btn').forEach(function (button) { button.addEventListener('click', updateVariant); });
    updateVariant();
  });
})();
